import { render, staticRenderFns } from "./DetalleNotaCredito.vue?vue&type=template&id=a615ef3c&scoped=true&lang=pug&"
import script from "./DetalleNotaCredito.vue?vue&type=script&lang=js&"
export * from "./DetalleNotaCredito.vue?vue&type=script&lang=js&"
import style0 from "./DetalleNotaCredito.vue?vue&type=style&index=0&id=a615ef3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a615ef3c",
  null
  
)

export default component.exports